/**
 * Text the public form page writes itself (as opposed to what the form's author wrote), in the
 * form's language. forms.language_id is 1 for Maltese and 2 for English; a form with neither is
 * shown in English, as it always was.
 */
export const MALTESE = 1;
export const ENGLISH = 2;

const en = {
  application: 'Application',
  submit: 'Submit Application',
  thisField: 'This field',
  required: (label) => `${label} is required`,
  invalidEmail: 'Please enter a valid email address',
  enter: (label) => `Enter ${label}`,
  enterAnswer: 'Enter your answer',
  select: (label) => `Select ${label}`,
  selectOption: 'Select an option',
  selectDate: 'Select date',
  noOptions: 'No options configured for this field',
  full: 'FULL',
  other: 'Other',
  pleaseSpecify: 'Please specify',
  specifyAnswer: 'Please specify your answer',
  picks: (min, max) => {
    const options = (n) => `${n} option${n === 1 ? '' : 's'}`;
    if (min && max) return min === max ? `Pick exactly ${options(min)}` : `Pick ${min} to ${max} options`;
    if (min) return `Pick at least ${options(min)}`;
    if (max) return `Pick up to ${options(max)}`;
    return null;
  },
  selectFile: 'Select File',
  invalidFile: 'Invalid File',
  invalidFileType: (ext, allowed) => `Invalid file type ".${ext}". Allowed types: ${allowed}`,
  fileTooLarge: (name, size, max) => `File "${name}" is too large (${size}MB). Maximum size: ${max}MB`,
  fileLimits: (types, max) => `Allowed: ${types || 'All types'} | Max size: ${max}MB`,
  submitted: 'Application submitted successfully!',
  submittedDetail: 'A representative will get back to you once it is vetted.',
  unavailable: 'Form Currently Unavailable',
  unavailableDetail: 'This form is currently inactive and not accepting submissions. Please check back later or contact us for more information.',
  redirectingToPayment: 'Submission successful! Redirecting to payment...',
  workshopsFull: 'One or more selected workshops are now full. Please refresh the page and select different options.',
  submitFailed: 'Failed to submit application',
};

// Maltese counts: 1 takes the singular, 2 to 10 the plural, 11 to 19 "-il" and the singular, then the singular.
const mtOptions = (n) => {
  if (n >= 2 && n <= 10) return `${n} għażliet`;
  if (n >= 11 && n <= 19) return `${n}-il għażla`;
  return `${n} għażla`;
};

const mt = {
  application: 'Applikazzjoni',
  submit: 'Ibgħat l-Applikazzjoni',
  thisField: 'Din il-mistoqsija',
  // Not every field is a question, so the message doesn't name it.
  required: () => 'Tweġiba meħtieġa',
  invalidEmail: 'Daħħal indirizz tal-email validu',
  enter: (label) => `Daħħal ${label}`,
  enterAnswer: 'Ikteb it-tweġiba tiegħek',
  select: (label) => `Agħżel ${label}`,
  selectOption: 'Agħżel għażla',
  selectDate: 'Agħżel data',
  noOptions: 'M’hemmx għażliet għal din il-mistoqsija',
  full: 'MIMLI',
  other: 'Oħra',
  pleaseSpecify: 'Speċifika',
  specifyAnswer: 'Jekk jogħġbok speċifika t-tweġiba tiegħek',
  picks: (min, max) => {
    if (min && max) return min === max ? `Agħżel eżatt ${mtOptions(min)}` : `Agħżel minn ${min} sa ${mtOptions(max)}`;
    if (min) return `Agħżel mill-inqas ${mtOptions(min)}`;
    if (max) return `Agħżel sa ${mtOptions(max)}`;
    return null;
  },
  selectFile: 'Agħżel Fajl',
  invalidFile: 'Fajl Mhux Validu',
  invalidFileType: (ext, allowed) => `Dan it-tip ta’ fajl (".${ext}") mhux aċċettat. Tipi aċċettati: ${allowed}`,
  fileTooLarge: (name, size, max) => `Il-fajl "${name}" huwa kbir wisq (${size}MB). Daqs massimu: ${max}MB`,
  fileLimits: (types, max) => `Aċċettati: ${types || 'Kull tip'} | Daqs massimu: ${max}MB`,
  submitted: 'L-applikazzjoni ntbagħtet b’suċċess!',
  submittedDetail: 'Rappreżentant se jikkuntattjak hekk kif l-applikazzjoni tiġi eżaminata.',
  unavailable: 'Il-Formola Mhix Disponibbli Bħalissa',
  unavailableDetail: 'Din il-formola mhix attiva u mhix qed taċċetta applikazzjonijiet. Erġa’ pprova aktar tard jew ikkuntattjana għal aktar informazzjoni.',
  redirectingToPayment: 'L-applikazzjoni ntbagħtet! Issa se tittieħed għall-ħlas...',
  workshopsFull: 'Waħda jew aktar mill-għażliet li għażilt imtlew. Biex taġġorna, iftaħ il-paġna mill-ġdid u agħżel għażliet oħra.',
  submitFailed: 'L-applikazzjoni ma ntbagħtitx',
};

export const formStrings = (languageId) => (Number(languageId) === MALTESE ? mt : en);
